<template>
  <span class="gs-val" :class="{ 'is-empty': !has }">{{ has ? text : empty }}</span>
</template>

<script>
export default {
  name: 'GsVal',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    empty: {
      type: String,
      default: '暂无'
    }
  },
  computed: {
    text() {
      return this.value == null ? '' : String(this.value).trim()
    },
    has() {
      return this.text !== '' && this.text !== 'null' && this.text !== 'undefined'
    }
  }
}
</script>

<style scoped>
.gs-val {
  color: #111824;
  word-break: break-all;
}
.gs-val.is-empty {
  display: inline-block;
  min-width: 42px;
  padding: 0 8px;
  height: 22px;
  line-height: 22px;
  background: #F4F8FF;
  border: 1px dashed #C5D8F7;
  border-radius: 4px;
  color: #8A97AB;
  font-size: 12px;
  font-weight: 400;
}
</style>
